// Auto-generated from Social_Media_Posts_Jul-Oct_2024.xlsx (all entries, daily sums)
// 1-based month: d(2024, 7) => Jul 1, 2024
export const d = (y, m) => new Date(y, m - 1, 1).getTime();
export const dataPoints = [
  { date: d(2024, 1), X: 238, LN: 211, YouTube: 193 },
  { date: d(2024, 2), X: 168, LN: 223, YouTube: 182 },
  { date: d(2024, 3), X: 193, LN: 191, YouTube: 209 },
  { date: d(2024, 4), X: 233, LN: 293, YouTube: 281 },
  { date: d(2024, 5), X: 251, LN: 251, YouTube: 188 },
  { date: d(2024, 6), X: 250, LN: 249, YouTube: 200 },
  { date: d(2024, 7), X: 204, LN: 229, YouTube: 253 },
  { date: d(2024, 8), X: 189, LN: 205, YouTube: 212 },
  { date: d(2024, 9), X: 234, LN: 238, YouTube: 222 },
  { date: d(2024, 10), X: 228, LN: 226, YouTube: 211 },
  { date: d(2024, 11), X: 249, LN: 265, YouTube: 179 },
  { date: d(2024, 12), X: 249, LN: 241, YouTube: 247 },
];
